import type { CustomComponentEntry } from 'schema';
import { CustomComponent } from './CustomComponent';

export const ContentfulCustomComponent = (props: CustomComponentEntry) => (
  <CustomComponent {...props} />
);
